(function(){
  "use strict";

  // ---- Mobile menu drawer ----
  function bindDrawer(){
    var burger=document.querySelector('[data-burger]');
    var drawer=document.querySelector('[data-drawer]');
    if(!burger||!drawer) return;
    var open=function(){drawer.classList.add('open');document.body.style.overflow='hidden';};
    var close=function(){drawer.classList.remove('open');document.body.style.overflow='';};
    burger.addEventListener('click',open);
    drawer.querySelectorAll('[data-drawer-close],.scrim').forEach(function(el){el.addEventListener('click',close);});
  }

  // ---- Quantity steppers ----
  function bindQty(){
    document.querySelectorAll('[data-qty]').forEach(function(box){
      var input=box.querySelector('input');
      box.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click',function(){
          var step=b.getAttribute('data-step')==='down'?-1:1;
          var v=Math.max(1,(parseInt(input.value,10)||1)+step);
          input.value=v; input.dispatchEvent(new Event('change',{bubbles:true}));
        });
      });
    });
  }

  // ---- Product variant selection ----
  function bindProductForm(){
    var form=document.querySelector('[data-product-form]');
    if(!form) return;
    var dataEl=document.querySelector('[data-variants-json]');
    if(!dataEl) return;
    var variants=[]; try{variants=JSON.parse(dataEl.textContent);}catch(e){return;}
    var idInput=form.querySelector('[name="id"]');
    var priceEl=document.querySelector('[data-price]');
    var atcText=document.querySelector('[data-atc-text]');
    var atcBtn=form.querySelector('[data-atc]');
    var mPrice=document.querySelector('[data-m-price]');
    var money=window.JB_money||function(c){return (c/100).toFixed(2).replace('.',',')+' €';};
    var galleryMain=document.querySelector('[data-gallery-main]');

    function attr(value){
      return String(value||'').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;');
    }
    function norm(value){
      return String(value||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,' ').trim();
    }
    function setActiveThumb(mediaId){
      var matched=false;
      document.querySelectorAll('[data-gallery-thumb]').forEach(function(t){
        var on=mediaId&&String(t.getAttribute('data-media-id'))===String(mediaId);
        t.classList.toggle('on',!!on);
        if(on) matched=true;
      });
      return matched;
    }
    function renderGalleryImage(image,mediaId){
      if(!galleryMain||!image||!image.src) return false;
      var html='<img src="'+attr(image.src)+'"';
      if(image.srcset) html+=' srcset="'+attr(image.srcset)+'" sizes="(min-width: 760px) 50vw, 100vw"';
      html+=' alt="'+attr(image.alt)+'" width="760" height="760" loading="eager" fetchpriority="high" decoding="async">';
      galleryMain.innerHTML=html;
      setActiveThumb(mediaId);
      return true;
    }
    function fallbackImageFromOptions(options){
      var optionTokens=(options||[]).map(norm).filter(function(v){return v.length>1;});
      if(!optionTokens.length) return null;
      var thumbs=Array.prototype.slice.call(document.querySelectorAll('[data-gallery-thumb]'));
      for(var i=0;i<thumbs.length;i++){
        var t=thumbs[i];
        var hay=norm((t.getAttribute('data-alt')||'')+' '+(t.getAttribute('data-src')||''));
        if(!hay) continue;
        for(var j=0;j<optionTokens.length;j++){
          if(hay.indexOf(optionTokens[j])!==-1){
            return {
              src:t.getAttribute('data-src'),
              srcset:t.getAttribute('data-srcset'),
              alt:t.getAttribute('data-alt')||''
            };
          }
        }
      }
      return null;
    }

    function currentOptions(){
      return Array.prototype.map.call(form.querySelectorAll('[data-opt]'),function(group){
        var sel=group.querySelector('input:checked');
        return sel?sel.value:null;
      });
    }
    function match(){
      var opts=currentOptions();
      return variants.find(function(v){
        return opts.every(function(o,i){return o===null||v.options[i]===o;});
      });
    }
    function update(){
      var v=match()||variants[0];
      if(!v) return;
      var opts=currentOptions();
      if(idInput) idInput.value=v.id;
      var price=money(v.price);
      var cmp=(v.compare_at_price&&v.compare_at_price>v.price)?(' <s>'+money(v.compare_at_price)+'</s>'):'';
      if(priceEl) priceEl.innerHTML=price+cmp;
      if(mPrice) mPrice.textContent=price;
      if(atcText) atcText.textContent=v.available?('In den Warenkorb · '+price):'Ausverkauft';
      if(atcBtn) atcBtn.disabled=!v.available;
      // update label readouts
      document.querySelectorAll('[data-opt-readout]').forEach(function(r){
        var idx=parseInt(r.getAttribute('data-opt-readout'),10);
        var g=form.querySelectorAll('[data-opt]')[idx];
        var sel=g&&g.querySelector('input:checked'); if(sel) r.textContent=sel.value;
      });
      if(v.featured_image&&v.featured_image.src){
        renderGalleryImage(v.featured_image,v.featured_media_id);
      }else{
        renderGalleryImage(fallbackImageFromOptions(opts),null);
      }
    }
    form.querySelectorAll('[data-opt] input').forEach(function(i){i.addEventListener('change',update);});
    update();
  }

  // ---- Product gallery ----
  function bindGallery(){
    var main=document.querySelector('[data-gallery-main]');
    if(!main) return;
    function attr(value){
      return String(value||'').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;');
    }
    document.querySelectorAll('[data-gallery-thumb]').forEach(function(t){
      t.addEventListener('click',function(){
        document.querySelectorAll('[data-gallery-thumb]').forEach(function(x){x.classList.remove('on');});
        t.classList.add('on');
        var src=t.getAttribute('data-src');
        var srcset=t.getAttribute('data-srcset');
        var alt=t.getAttribute('data-alt')||'';
        if(src){
          var html='<img src="'+attr(src)+'"';
          if(srcset) html+=' srcset="'+attr(srcset)+'" sizes="(min-width: 760px) 50vw, 100vw"';
          html+=' alt="'+attr(alt)+'" width="760" height="760" loading="eager" decoding="async">';
          main.innerHTML=html;
        }
      });
    });
  }

  // ---- Sticky mobile ATC ----
  function bindStickyAtc(){
    var bar=document.querySelector('[data-mobile-atc]');
    var anchor=document.querySelector('[data-atc]');
    if(!bar||!anchor) return;
    var io=new IntersectionObserver(function(e){
      bar.style.display=(e[0].isIntersecting||window.innerWidth>=760)?'none':'flex';
    });
    io.observe(anchor);
  }

  // ---- Free shipping bar (cart) ----
  function bindShipBar(){
    var bar=document.querySelector('[data-shipbar]');
    if(!bar) return;
    var goal=parseInt(bar.getAttribute('data-goal'),10)||4900;
    var total=parseInt(bar.getAttribute('data-total'),10)||0;
    var pct=Math.min(100,Math.round(total/goal*100));
    var fill=bar.querySelector('.fill'); if(fill) fill.style.width=pct+'%';
  }

  function init(){bindDrawer();bindQty();bindProductForm();bindGallery();bindStickyAtc();bindShipBar();}
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();
